export enum PreRegisterTypeEnum {
  PRE_REGISTER = 'WMSF_PR',
  WAREHOUSE_RECEIPT = 'WMSF_WR',
  SHIPMENT = 'FREIGHT_SP'
}
